//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { type ChatMessage } from './ChatTypes';

// The one wording of the note, shared with the tests that look for it.
export const datasetNoteText = (dataset: string | null): string =>
  `Dataset changed to ${dataset ?? 'none'}.`;

/**
 * Where the transcript should say the dataset changed: a map from a
 * message index to the dataset in force from that message on.  A turn's
 * dataset is recorded on the message that ended it, but the note belongs
 * before the user message that started it, so each recorded dataset that
 * differs from the last recorded one is attributed to the nearest user
 * message before it.  A first turn gets no note: the header already shows
 * its dataset, and a change is what the reader needs pointed out.
 */
export const datasetNotes = (
  messages: readonly ChatMessage[]
): Map<number, string | null> => {
  const notes = new Map<number, string | null>();
  // undefined until the first message with a recorded dataset.
  let previous: string | null | undefined;
  let lastUser = -1;
  messages.forEach((message, index) => {
    if (message.role === 'user') lastUser = index;
    if (message.dataset === undefined) return;
    if (previous !== undefined && message.dataset !== previous)
      notes.set(lastUser === -1 ? index : lastUser, message.dataset);
    previous = message.dataset;
  });
  return notes;
};
